<template>
  <div class="pb-2 max-h-full h-full">
    <div class="max-h-full h-full">
      <div class="flex min-h-full h-full overflow-hidden">
        <div class="flex-grow max-h-full overflow-auto py-3">
          <div class="px-5">
            <VariableSelect v-model="pdf.variable" label="Assign to Variable" class="flex-grow" :filter-data-type="['PDF']" @update:modelValue="emitPayload" />
            <PhraseEditor v-model="pdf.file_name" :items="variables" label="File Name" class="mt-3 flex-grow" @update:modelValue="emitPayload" />
            <FormSelect v-model="pdf.template" :options="templates" default-reducer append-to-body label="Template" class="mt-3 flex-grow" @update:modelValue="emitPayload" />
            <VariableSelect v-model="pdf.data" :items="variables" multiple label="Template Variables" class="mt-3 flex-grow" @update:modelValue="emitPayload" />
            <div class="mt-3 w-full">
              <label class="block text-12 mb-1">Inject Content Using AI</label>
              <Toggle v-model="pdf.auto_inject" @update:modelValue="emitPayload" />
            </div>
            <FormSelect
              v-if="pdf.auto_inject"
              :label="$t('evaluate.provider')"
              v-model="pdf.provider"
              :options="providers"
              :selectable="(option) => !option.disabled"
              :reduce="(option) => option.value"
              class="w-full mt-2"
              @update:modelValue="onProviderChange"
            />
            <FormSelect
              v-if="pdf.auto_inject"
              :label="$t('evaluate.model')"
              v-model="pdf.model"
              :options="models"
              append-to-body
              :reduce="(option) => option.value"
              class="w-full mt-3"
              @update:modelValue="emitPayload"
            />
            <VariableSelect
              v-if="pdf.auto_inject"
              v-model="pdf.content"
              :append-to-body="false"
              :filterDataType="['Text']"
              label="Text Content for AI"
              @update:modelValue="emitPayload"
              multiple
              class="w-full mt-3"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import uuidv4 from '../../../helpers/uuid';
import debounce from '../../../helpers/debounce';
import EvaluateItemsConfig from './EvaluateItemsConfig';

export default {
  name: 'DocumentPDFConfig',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pdf: structuredClone(EvaluateItemsConfig['document-pdf'].payload),
    };
  },
  created() {
    this.pdf = { ...this.pdf, ...JSON.parse(JSON.stringify(this.item.payload)) };
  },
  computed: {
    ...mapState(['projectData', 'availableAIProviders']),
    ...mapGetters(['getProjectTemplates', 'getProjectAIProviderOptions']),
    templates() {
      return Object.keys(this.getProjectTemplates()).map((key) => ({
        label: this.getProjectTemplates()[key].name,
        value: key,
      }));
    },
    responseType() {
      return this.item.type;
    },
    payload() {
      return {
        id: this.item.id,
        type: this.item.type,
        payload: this.pdf,
      };
    },
    projectId() {
      return this.$route.params.projectId;
    },
    variables() {
      let variables = [];
      if (this.projectId && Object.keys(this.projectData).length) {
        variables = Object.keys(this.projectData?.[this.projectId]?.variables || {}).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) || [];
      }
      variables = variables.map((variable) => ({
        id: uuidv4(),
        value: variable,
      }));
      return variables;
    },
    providers() {
      return this.getProjectAIProviderOptions();
    },
    models() {
      if (!this.pdf.provider) return [];
      return Object.values(this.availableAIProviders[this.pdf.provider].models).map((item) => ({ label: `<b>${item.name}</b> - <i class="text-11">Cost: ${item.cost}</i>`, value: item.model }));
    },
  },
  methods: {
    // eslint-disable-next-line
    emitPayload: debounce(function () {
      this.$emit('update', structuredClone(this.payload));
    }, 300),
    onProviderChange() {
      this.pdf.model = '';
    },
  },
};
</script>
